<div class="subBlockContainer subBlockContainer-width" id="addazureri">
  <div class="subBlockContent">
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="title blade-title-font">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div>
      <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false"
      (currentLoadingStatus)="onLoading($event)"></loading-screen>
        <div class="searchInputGroup">
          <div class="searchIcon">
            <img src="../images/new_ui/filter.png">
          </div>
          <input class="searchInput" type="text" #searchValue placeholder="Filter" [(ngModel)]="searchCatalog"
              (ngModelChange)="filterAzureRiCatalogs()">
        </div>
        <div class="top-divider"></div>
        <!-- # brand filter -->
        <!-- <div class="listpart col-md-6">
          
        </div> -->
        <div class="align-center" *ngIf="!azureRiCatalog?.length && loadContent">
          <div class="noData-wrapper">
            <div>
                <img src="../../images/new_ui/no-subscription.png">
              </div>
              <label class="noData-label">
                We couldn't find any <br />
                Azure RI Catalogue
              </label>
            </div>
        </div>

        <div class="shared-outer-wrapper" *ngIf="azureRiCatalog?.length && loadContent">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="align-left" style="width: 20%">Product Id</th>
                <th scope="col" class="align-left" style="width: 60%">Azure RI Catalog</th>
                <th scope="col" class="align-center" style="width: 20%"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let catalogue of azureRiCatalogFilter">
                <td class="position-relative vertical-align-mid">
                  {{catalogue.productId}}
                </td>
                <td class="position-relative vertical-align-mid">
                  <span class="description-popup">{{catalogue.title}}</span>
                </td>
                <td class="align-center">
                  <button mat-button class="button button-red button-mid" (click)="selectAzureRiCatalogue(catalogue)">Select</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
  </div>
</div>

<router-outlet>